<template>
  <maintaincost-check
    :sna-id="snaId"
  >
    <template v-slot:footer>
      <check-module :title="`审批`">
        <check-handle-module
          :pass-dialog-txt="`审批通过后可进行费用划拨。`"
        ></check-handle-module>
      </check-module>
    </template>
  </maintaincost-check>
</template>

<script>
import maintaincostCheck from '@/views/workbench/workCheckManage/maintaincostCheck/maintaincostCheck'
import checkMixin from '@/mixin/checkMixin'
export default {
  name: 'maintaincostCheckView',
  components: {
    maintaincostCheck
  },
  mixins: [checkMixin],
  data () {
    return {
      checkDetailName: 'maintaincostcheckdetail'
    }
  }
}
</script>

<style scoped>

</style>
